<template>
  <div id="sales-return">
    <vs-card id="data-loading" class="vs-con-loading__container">
      <invoice-details :saleDetails.sync="saleDetails" />

      <invoice-item-details ref="invoiceItemDetails" :saleItems.sync="saleReturn" :saleDetails.sync="saleDetails" />

      <invoice-payment-details :salePayments.sync="salesPayments" />

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-8 flex flex-wrap items-center justify-start">
            <vs-button v-if="checkPermissionByIds([permissions.SALE_RETURN_ADD])" class="mr-2 vs-con-loading__container" id="add-expense-category-button" type="relief" @click="createSaleReturn">
              Save Changes
            </vs-button>
            <vs-button color="danger" type="relief" class="text-left" @click="$router.go(-1)">Cancel</vs-button>
          </div>
        </div>
      </div>
      <!-- End Save & Reset Button -->
    </vs-card>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import InvoiceDetails from '@/views/pos/components/SalesReturn/InvoiceDetails.vue'
import InvoiceItemDetails from '@/views/pos/components/SalesReturn/InvoiceItemDetails.vue'
import InvoicePaymentDetails from '@/views/pos/components/SalesReturn/InvoicePaymentDetails.vue'
import { paymentMixins } from '@/utils/paymentTypes'
import { weightMixins } from '@/utils/weightType'
import { taxMode, discountApplicableType } from '@/utils/enums'

export default {
  name: 'sales_return',

  data() {
    return {
      saleDetails: null,
      saleReturn: []
    }
  },

  // mounted property
  async mounted() {
    await this.getSaleById(this.$route.params.id)
    this.saleDetails = { ...this.sale, sales_return_date: new Date(), return_note: '' }
    this.saleReturn = this.salesItems.map((item) => ({
      ...item,
      return_qty: 0,
      purchase_qty: item.sales_qty,
      purchase_tot_price: item.tot_price
    }))

    if (this.saleDetails) {
      await this.managesalesReturnData()
    }
  },

  // computed property
  computed: {
    ...mapState('pos', ['loading', 'sale', 'salesItems', 'salesPayments']),
    ...mapState('product', ['categories']),
    ...mapState('permission', ['permissions']),
    ...mapGetters('auth', ['checkPermissionByIds'])
  },

  mixins: [paymentMixins],

  // methods
  methods: {
    ...mapActions('pos', { getSaleById: 'getSaleById', create_sale_return: 'create_sale_return_invoice' }),

    // manage sales return data
    async managesalesReturnData() {
      // if no record foun for previous sale return then do nothing
      if (!this.saleDetails.sales_return) {
        return null
      }

      this.saleDetails.sales_return.salesItemsReturn.forEach((element) => {
        const tempElementIndex = this.saleReturn.findIndex((elem) => elem.productId === element.productId)

        if (tempElementIndex > -1) {
          const tempSubTotal = this.saleReturn[tempElementIndex].sales_qty - element.return_qty

          this.saleReturn[tempElementIndex].purchase_qty = this.saleReturn[tempElementIndex].sales_qty
          this.saleReturn[tempElementIndex].city_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].city_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // city tax
          this.saleReturn[tempElementIndex].county_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].county_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // county tax
          this.saleReturn[tempElementIndex].excise_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].excise_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // exxcise tax
          this.saleReturn[tempElementIndex].state_tax_amt = (tempSubTotal * this.saleReturn[tempElementIndex].state_tax_amt) / this.saleReturn[tempElementIndex].sales_qty // state tax
          this.saleReturn[tempElementIndex].tot_taxes_amt = (tempSubTotal * this.saleReturn[tempElementIndex].tot_taxes_amt) / this.saleReturn[tempElementIndex].sales_qty // product total tax
          this.saleReturn[tempElementIndex].tot_discount = (tempSubTotal * this.saleReturn[tempElementIndex].tot_discount) / this.saleReturn[tempElementIndex].sales_qty // product discount
          this.saleReturn[tempElementIndex].sales_qty = this.saleReturn[tempElementIndex].sales_qty - element.return_qty // product quantity

          this.saleReturn[tempElementIndex].tot_price =
            this.saleReturn[tempElementIndex].tot_price - this.calculateReturnItemPrice(this.saleReturn[tempElementIndex], element.return_qty, element.discount_amount) // product total
        }
      })
    },

    // sale return
    async createSaleReturn() {
      const is_return_item = this.saleReturn.filter((element) => element.return_status === true)
      if (!is_return_item.length) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please check at least one of the products',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        this.$refs.invoiceItemDetails.$refs.itemCheck[0].$el.querySelector('input').focus()

        return false
      }

      const invalidReturnQty = is_return_item.filter((element) => element.return_qty <= 0)
      if (invalidReturnQty.length) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please add Return Quantity',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        this.$refs.invoiceItemDetails.$refs.itemReturnQty[0].$el.querySelector('input').focus()

        return false
      }

      // create sale return obj
      const createSaleReturnObj = await this.createSaleReturnObj()

      // create sales return invoice
      try {
        const { message } = await this.create_sale_return(createSaleReturnObj)

        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
        this.is_popup_active = false
        this.$router.push('/pos/invoice-list')
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // create sale return obj
    async createSaleReturnObj() {
      const sale_return_obj = {}

      const salesItemsReturn = []

      // loop through all items of invoices
      this.saleReturn.forEach((item) => {
        if (item.return_qty === 0) {
          return false
        }

        const temp_product_obj = {}

        temp_product_obj.productId = item.productId // product id
        temp_product_obj.return_qty = item.return_qty // return quantity
        temp_product_obj.price_per_unit = item.price_per_unit // price per obj
        temp_product_obj.discount_amount = (item.return_qty * item.tot_discount) / item.sales_qty || 0 // total discount (per product)
        temp_product_obj.city_tax = (temp_product_obj.return_qty * item.city_tax_amt) / item.sales_qty || 0 // city tax
        temp_product_obj.state_tax = (temp_product_obj.return_qty * item.state_tax_amt) / item.sales_qty || 0 // state tax
        temp_product_obj.excise_tax = (temp_product_obj.return_qty * item.excise_tax_amt) / item.sales_qty || 0 // excise tax
        temp_product_obj.county_tax = (temp_product_obj.return_qty * item.county_tax_amt) / item.sales_qty || 0 // county tax
        temp_product_obj.tot_taxes_amt = temp_product_obj.city_tax + temp_product_obj.state_tax + temp_product_obj.excise_tax + temp_product_obj.county_tax // total tax (per product)
        temp_product_obj.tot_per_unit = this.calculateItemPriceAndSubTotal(item) // sub total (per product)
        temp_product_obj.total_cost = temp_product_obj.tot_per_unit + temp_product_obj.tot_taxes_amt // total (per product = sub total + tax - discount)
        if ([this.categories.PLANT, this.categories.MATURE].includes(item.product.categoryId)) {
          temp_product_obj.plantIds = item.return_plants_id // all plants id of product that perchased
        }

        salesItemsReturn.push(temp_product_obj)
      })

      sale_return_obj.salesItemsReturn = salesItemsReturn // invoice items

      sale_return_obj.salesId = this.saleDetails.id // sale id
      sale_return_obj.return_date = this.saleDetails.sales_return_date // set invoice return date
      sale_return_obj.referenceNo = this.saleDetails.referenceNo // set reference no

      const tempSubTotal = sale_return_obj.salesItemsReturn.reduce((acc, item) => acc + item.tot_per_unit, 0)
      sale_return_obj.sub_total = tempSubTotal // sub total of invoice

      const tempTotalDiscount = sale_return_obj.salesItemsReturn.reduce((acc, item) => acc + item.discount_amount, 0)
      sale_return_obj.tot_discount = tempTotalDiscount // total discount of invoice

      sale_return_obj.tot_city_amt = sale_return_obj.salesItemsReturn.reduce((acc, item) => acc + item.city_tax, 0)
      sale_return_obj.tot_county_amt = sale_return_obj.salesItemsReturn.reduce((acc, item) => acc + item.county_tax, 0)
      sale_return_obj.tot_state_amt = sale_return_obj.salesItemsReturn.reduce((acc, item) => acc + item.state_tax, 0)
      sale_return_obj.tot_excise_amt = sale_return_obj.salesItemsReturn.reduce((acc, item) => acc + item.excise_tax, 0)
      sale_return_obj.tot_taxes_amt = sale_return_obj.tot_city_amt + sale_return_obj.tot_county_amt + sale_return_obj.tot_state_amt + sale_return_obj.tot_excise_amt // total tax of invoice
      sale_return_obj.grand_total = sale_return_obj.sub_total + sale_return_obj.tot_taxes_amt
      sale_return_obj.return_note = this.saleDetails.return_note

      return sale_return_obj
    },

    // calculate item price and sub total
    calculateItemPriceAndSubTotal(item) {
      const perItemTotalPrice = item.purchase_tot_price / item.purchase_qty
      return Math.max(0, perItemTotalPrice * item.return_qty)
    },

    // calculate return item price
    calculateReturnItemPrice(item, returnQty, discountAmount) {
      if (this.sale.tax_mode === taxMode.taxIncluded && item.discount_amount_type === discountApplicableType.postTax) {
        return (item.product.sales_price * returnQty - discountAmount) / (1 + item.total_tax_percentage / 100)
      } else {
        return item.price_per_unit * returnQty - discountAmount
      }
    }
  },

  // filters
  filters: {
    // currencyFilter rounded to 2 point
    currencyFilter(value) {
      return paymentMixins.methods.mathRound(value, 2)
    },

    //weightFilter rounded conversation
    weightFilter(value) {
      return weightMixins.methods.mathRound(value, 3)
    }
  },

  // watchers
  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#sales-return',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('#sales-return > .con-vs-loading')
      }
    }
  },

  // components
  components: {
    InvoiceDetails,
    InvoiceItemDetails,
    InvoicePaymentDetails
  }
}
</script>

<style lang="scss">
#sales-return {
  .vs-input-number {
    background: none;
    width: 88px;
  }
}
</style>
